import { render, staticRenderFns } from "./ThermalModuleTestDataStatistc.vue?vue&type=template&id=a0261974"
import script from "./ThermalModuleTestDataStatistc.vue?vue&type=script&lang=js"
export * from "./ThermalModuleTestDataStatistc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports